"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGraphqlQuery = useGraphqlQuery;
var _react = require("react");
var _swr = _interopRequireWildcard(require("swr"));
var _middleware = require("../middleware");
var _utils = require("../utils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/* eslint-disable @typescript-eslint/strict-boolean-expressions -- okay in this case as value can be generic */

/**
 * It takes a GraphQL query, variables, and a url, and returns a SWR response
 * @param {QueryOptions} [options] - The parameters represents an object which contains properties for the Graphql fetcher function
 */
function useGraphqlQuery(options) {
  const {
    url,
    skip,
    swrConfig,
    createCacheKey,
    onError,
    timeout,
    ...fetcherOptions
  } = options ?? {
    skip: true
  };
  const {
    cache
  } = (0, _swr.useSWRConfig)();
  const cacheKey = (0, _react.useMemo)(() => createCacheKey ? createCacheKey({
    url,
    ...fetcherOptions
  }) : (0, _utils.createSimplifiedCacheKey)({
    url,
    ...fetcherOptions
  }), [createCacheKey, url, fetcherOptions]);
  const normalizedFallbackData = (0, _react.useMemo)(() => {
    if (!swrConfig?.fallbackData) {
      return undefined;
    }
    return {
      ...swrConfig.fallbackData,
      errors: []
    };
  }, [swrConfig?.fallbackData]);
  const configForSWR = (0, _react.useMemo)(() => swrConfig ? {
    ...swrConfig,
    fallbackData: normalizedFallbackData,
    use: [...(swrConfig.use ?? []), ...(normalizedFallbackData ? [_middleware.initialDataMiddleware] : [])],
    revalidateOnMount: !cache.get((0, _swr.unstable_serialize)(cacheKey))
  } : {
    revalidateOnMount: !cache.get((0, _swr.unstable_serialize)(cacheKey))
  }, [swrConfig, normalizedFallbackData, cache, cacheKey]);
  return (0, _swr.default)(skip ? null : cacheKey, async () => (0, _utils.fetchGraphql)({
    url,
    onError,
    timeout,
    ...fetcherOptions
  }), configForSWR);
}
